import { HealthDataFieldsType } from 'types/patients';

import { GANDER_FEMALE_VALUE } from './profile';

export const HEALTH_DATA_FIELDS: HealthDataFieldsType[] = [
  {
    title: 'height',
    stepKey: 'height',
    unitKey: 'heightUnit'
  },
  {
    title: 'weight',
    stepKey: 'weight',
    unitKey: 'weightUnit'
  },
  {
    title: 'chronic_conditions',
    stepKey: 'chronic_conditions',
    optionsKey: 'chronic_conditions_options',
    otherKey: 'chronic_conditions_other'
  },
  {
    title: 'family_history',
    stepKey: 'family_history',
    optionsKey: 'family_history_options',
    otherKey: 'family_history_other'
  },
  {
    title: 'profile_allergies',
    stepKey: 'allergies',
    otherKey: 'allergies_other'
  },
  {
    title: 'surgical_history',
    stepKey: 'surgical_history',
    otherKey: 'surgical_history_other'
  },
  {
    title: 'medication',
    stepKey: 'medication',
    otherKey: 'medication_other'
  },
  {
    title: 'profile_medication_history',
    stepKey: 'medication_history'
  },
  {
    title: 'profile_last_vaccination',
    stepKey: 'vaccination',
    optionsKey: 'vaccination'
  },
  {
    title: 'profile_physical_disabilities',
    stepKey: 'disabilities'
  },
  {
    title: 'profile_smoke',
    stepKey: 'smoke',
    optionsKey: 'smoke_other'
  },
  {
    title: 'profile_alcohol',
    stepKey: 'alcohol',
    optionsKey: 'alcohol_other'
  },
  {
    title: 'profile_sleep',
    stepKey: 'sleep',
    optionsKey: 'sleep'
  },
  {
    title: 'pregnant',
    stepKey: 'pregnant',
    gender: GANDER_FEMALE_VALUE
  },
  {
    title: 'regular_cycle',
    stepKey: 'regular_cycle',
    gender: GANDER_FEMALE_VALUE
  }
];

export enum AnalyzeStatuses {
  high = 'High',
  low = 'Low',
  norm = 'Norm'
}
